"use client";

import { ImageShowcase } from "@/app/(marketing)/components/demo/showcases/ImageShowcase";
import { StarPoint } from "@/app/(marketing)/components/demo/showcases/StarPoint";
import { ButtonLink } from "@/components/buttons/ButtonLink";
import screenshot from "@/public/images/appScreenshots/make-harmonies.png";

export function HarmonyMakerShowcase() {
  return (
    <ImageShowcase
      screenshot={screenshot}
      headingText="Make harmonies"
      altText="Screenshot of make harmonies page"
    >
      <ul className="flex flex-col gap-y-2">
        <StarPoint>
          Create harmonies using Audimee's royalty-free voices, as well as your
          own
        </StarPoint>
        <StarPoint>
          Save your favorite harmony compositions as presets
        </StarPoint>
      </ul>
      <ButtonLink
        external={false}
        href="/harmonies"
        className="mt-6 block w-fit"
      >
        Explore
      </ButtonLink>
    </ImageShowcase>
  );
}
